import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useLazyGetPostQuery } from '../../services/posts.api';
import { baseUrlFiles } from '../../configs/api/api.config';
import { BackButton } from '../../shared/ui';

const Post = () => {
  const params = useParams();
  const [getPost, { data }] = useLazyGetPostQuery();

  useEffect(() => {
    if (params?.id) {
      getPost(params.id);
    }
  }, [params, getPost]);

  if (!data) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <div className="hidden md:flex mb-[10px]">
        <BackButton className="m-1.5" to="/info" />
      </div>
      <div className="flex items-start mb-5">
        <div className="hidden md:flex w-full md:w-[43%] object-contain md:mr-4 shrink-0 xl:pt-[10px]">
          <img className="w-full h-full object-contain" src={baseUrlFiles + data.image} alt="" />
        </div>
        <div>
          <div className="flex gap-[14px] text-heading-md md:text-display-s lg:text-display-xl xl:text-display-xl leading-[1rem] lg:leading-[45px] xl:leading-[75px] mb-4 md:mb-5 lg:mb-[25px]">
            <BackButton className="md:hidden -m-1.5" to="/info" />
            <span>{data?.title}</span>
          </div>
          <p className="text-ui-strong md:text-ui-strong xl:text-heading-md text-ink">{data.excerpt}</p>
        </div>
      </div>
      <div className="bg-surface-muted md:bg-white rounded-card order-2 px-[15px]">
        <img
          className="md:hidden w-full md:w-[50%] md:float-right md:ml-4 mb-[20px] mt-0 order-2"
          src={baseUrlFiles + data.image}
          alt=""
        />
        <div className="order-3" dangerouslySetInnerHTML={{ __html: data.content }}></div>
      </div>
    </div>
  );
};

export default Post;
